import { getOverrideRemoteEntries } from '../getOverrideRemoteEntries';
import { loadRemote } from './loadRemote';
let microfrontendConfig = null;
/*
 * Allows overriding MFE entry points on localhost and in QA.
 * To set a override just add it to your local storage by running the following in your Inspector console:
 * localStorage.setItem('dev.override.remoteEntries', JSON.stringify({ dashboard_compass: {"entry_point":"https://hub-vnext.cko-qa.ckotech.co/mf/compass/remoteEntry.js","config":"https://hub-vnext.cko-qa.ckotech.co/mf/compass/config"}}))
 */
const getEnvOverrides = (env) => {
    if ((env === 'qa' || env === 'local') && !document.domain.endsWith('.checkout.com')) {
        return getOverrideRemoteEntries();
    }
    return {};
};
export const initMicroFrontendConfig = (mfConfig, env) => {
    if (microfrontendConfig) {
        throw new Error('The microfrontend config has already been initialized, please ensure you only call initMicroFrontendConfig once');
    }
    const overrides = getEnvOverrides(env);
    microfrontendConfig = { ...mfConfig, ...overrides };
};
export const loadComponent = (name, module, fallback = () => Promise.resolve({ default: () => null })) => {
    return async () => {
        if (microfrontendConfig === null) {
            throw new Error('microfrontendConfig is not set, please call the initMicroFrontendConfig function');
        }
        let factory;
        try {
            const mfConfig = microfrontendConfig[name];
            if (!mfConfig) {
                throw new Error(`no microfrontend config found for ${name}`);
            }
            const container = await loadRemote(name, mfConfig);
            if (!container.get) {
                throw new Error(`Cannot load external remote: ${name}`);
            }
            factory = await container.get(module);
            if (!factory) {
                throw new Error(`Cannot load ${module} in remote: ${name}`);
            }
        }
        catch (error) {
            // Log stack trace to console to avoid swallowing errors from mounting the MF code.
            // eslint-disable-next-line no-console
            console.error(error);
            return fallback();
        }
        const Module = factory();
        return Module;
    };
};
